<template>
  <div v-if="content.show" class="field" :class="content.errorMessage?'errorBorder':''">
    <p class="text">
      <span>{{content.order}}</span>{{content.title}}
    </p>
    <div class="scale-rating">
      <table>
        <thead>
          <tr class="normalTr">
            <th v-for="(item,index) in content.fixArr">
              {{item}}
            </th>
          </tr>
        </thead>
        <tr>
          <td v-for="(item,index) in content.fixArr.length" @click="selectCurrent(index,content.num,content.type,item)">
            <a class="rate-off" :class="selected[index]?'rate-on':''">{{item}}</a>
          </td>
        </tr>
      </table>
    </div>
    <div class="errorMessage">{{content.errorMessage}}</div>
  </div>
</template>
<script>
export default {
  props:{
    content: Object
  },
  data() {
    return {
      answer: ['1', '2', '3', '4', '5', '6', '7', '8', '9'],
      selected:[false, false, false, false, false,false, false, false, false]
    }
  },
  methods:{
    selectCurrent(i,num,type) {
      let self = this
      self.selected.map(function(item,index){
        if(index==i){
          self.$set(self.selected,index,true)
        }else{
          self.$set(self.selected,index,false)
        }
      })
      self.$emit('listenToChildEvent',i+1,num,type)
    }
  }
}
</script>
<style lang="stylus" scoped>
  .scale-rating
    width:94%
    background-color: #ffffff
    margin:auto
    padding:0.1rem
    border:1px solid #d5d5d5
  table th
    padding:0.16rem 0;
    width: 9%;
    text-align:center;
    font-weight:normal;
  table th:first-child,
  table th:last-child
    width: 13%;
  table td
    border-top: 1px solid #dbdbdb;
    padding: 0.2rem 0;
    text-align :center;
    .rate-off
      width: 21px;
      height: 21px;
      text-decoration: none;
      border-radius: 30px;
      color: #333;
      border: 1px solid #cacece;
      cursor: default;
      display: inline-block;
      background: #fafafa;
      line-height: 19px;
      text-align: center;
    .rate-on
      background-color: #53a4f4 !important;
      border: 1px solid #53a4f4;
      position: relative;
      color: #fff;
</style>
